import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Work } from './pages/Work';
import { WorkDetail } from './pages/WorkDetail';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlynw8guiagc">
      <ScrollToTop data-id="element-1" data-mp="2rl6v15emuqtr" />
      <div className="flex min-h-screen w-full flex-col bg-paper font-sans text-ink" data-id="element-2" data-mp="2riknh5rqsbbj">
        <Routes data-id="element-3" data-mp="2mjpvbd7vxaer">
          <Route path="/" element={<Home data-id="element-5" data-mp="31b8ko1mmwhas" />} data-id="element-4" data-mp="31aqeac69cmp5" />
          <Route path="/work" element={<Work data-id="element-7" data-mp="31c1iue7j1yhb" />} data-id="element-6" data-mp="31brzh9gzmpkl" />
          <Route path="/work/:slug" element={<WorkDetail data-id="element-9" data-mp="2wjqg73lejyl2" />} data-id="element-8" data-mp="2wk09p15nonvi" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-11" data-mp="2whxd1y9zzwht" />} data-id="element-10" data-mp="2wifgbev2vaz8" />
        </Routes>
      </div>
    </BrowserRouter>;
}